import { defineStore } from 'pinia'
import type { YouTubeBubble } from '~/stores/interfaces'

export const useYouTubeStore = defineStore('youtube', {
  state: () => ({
    searchQuery: '',
    videos: [] as YouTubeBubble[],
  }),

  actions: {
    setVideos(videos: YouTubeBubble[]) {
      log(
        'YouTubeStore - Setting videos:',
        videos.map((v) => ({
          uuid: v.uuid,
          watched: v.meta?.watched,
          meta: v.meta,
        }))
      )
      this.videos = videos
    },

    updateVideo(updatedVideo: YouTubeBubble) {
      log('YouTubeStore - Updating video:', {
        uuid: updatedVideo.uuid,
        oldState: this.videos.find((v) => v.uuid === updatedVideo.uuid)?.meta?.watched,
        newState: updatedVideo.meta?.watched,
        oldMeta: this.videos.find((v) => v.uuid === updatedVideo.uuid)?.meta,
        newMeta: updatedVideo.meta,
      })

      // Create a new array to ensure reactivity
      this.videos = this.videos.map((video) =>
        video.uuid === updatedVideo.uuid ? { ...updatedVideo } : video
      )
    },

    removeVideo(uuid: string) {
      this.videos = this.videos.filter((video) => video.uuid !== uuid)
    },

    // ... other actions
  },
})
